// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"312":"1be19f01","979":"a79429ac"}[chunkId] + ".js";
};